import React from 'react';
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from '../redux/store';

type Props = {
  children: React.ReactNode,
  redirect?: string
}

const PublicRouteOrganizer: React.FC<Props> = ({ children, redirect }) => {
  const organizerToken = useSelector((state: RootState) => state.organizer.accessToken);
  const ownerToken = useSelector((state: RootState) => state.owner.accessToken);
  const storeToken = useSelector((state: RootState) => state.store.accessToken);
  const adminToken = useSelector((state: RootState) => state.admin.accessToken);


  // إذا يوجد token → إعادة التوجيه
  if (organizerToken) {
    return <Navigate to={redirect ? redirect : "/organizer"} replace />;
  }
  // لو أي واحد مسجل دخول
  if (adminToken) return <Navigate to={redirect ? redirect : "/admin"} replace />;
  if (storeToken) return <Navigate to={redirect ? redirect : "/store/dashboard"} replace />;
  if (ownerToken) return <Navigate to={redirect ? redirect : "/owner"} replace />;

  return <>{children}</>;
}

export default PublicRouteOrganizer;
